import styled from 'styled-components'

export const Container = styled.div`
  padding: 0 10% 0 10%;
  margin-top: 25%;
`
